import Controller from "./userVerifications.controller";
import template from "./userVerifications.html";

const userVerifications = {
  template,
  controller: Controller,
};

export default userVerifications;



// WEBPACK FOOTER //
// ./src/pages/userVerifications/userVerifications.component.js